<template>
  <div class="upload-file-btn">
    <input
      ref="fileInput"
      :multiple="multiple"
      :accept="accept"
      :disabled="disabled"
      type="file"
      style="display: none; height: 0;"
      @change="onFileChange"
    >
    <v-btn class="upload-file-btn__main-btn" :disabled="disabled" @click.native="onClick" color="#fff">
      <slot>Upload</slot>
    </v-btn>
    <div class="upload-file-btn__info" v-if="fileInputInfo.length > 0">
      <div class="body-2">
        <div v-if="value.length">
          {{ fileName }} ({{fileInputInfo.size}} in total)
          <v-btn icon fap color="primary" small @click="clearInput"><v-icon>mdi-close</v-icon></v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  const getFilesSize = (files) => {
    if (!files) {
      return
    }
    let size
    let sizeInfoText
    const length = files.length
    const sizeInByte = files.reduce((sum, { size }) => {
      sum += size
      return sum
    }, 0)
    const byteNumber = 1000 // 1024
    if (sizeInByte > (byteNumber * byteNumber * byteNumber)) {
      sizeInfoText = 'gB'
      size = sizeInByte / (byteNumber * byteNumber * byteNumber)
    } else if (sizeInByte > (byteNumber * byteNumber)) {
      sizeInfoText = 'MB'
      size = sizeInByte / (byteNumber * byteNumber)
    } else if (sizeInByte > byteNumber) {
      sizeInfoText = 'kB'
      size = sizeInByte / byteNumber
    } else {
      sizeInfoText = 'B'
      size = sizeInByte
    }
    if (sizeInfoText !== 'B') {
      size = size.toFixed(1)
    }
    return {
      size: `${size} ${sizeInfoText}`,
      length
    }
  }
  export default {
    name: 'file-upload-button',
    props: ['value', 'disabled', 'multiple', 'accept'],
    model: {
      prop: 'value',
      event: 'change'
    },
    data: () => ({
      fileInputInfo: {
        size: 0,
        length: 0
      },
      fileName: null
    }),
    watch: {
      value (val) {
        if (!_.isEqual(val, this.$refs.fileInput.files)) {
          // this.clearInput()
        }
      }
    },
    methods: {
      onClick () {
        if (!this.disabled) {
          this.$refs.fileInput.click()
        }
      },
      onFileChange ($event) {
        const files = $event && $event.target ? [...$event.target.files] : {}
        if (files && files.length) {
          this.fileInputInfo = getFilesSize(files)
          this.setFileName(files)
          this.$emit('change', files)
        } else {
          this.fileInputInfo = {
            size: 0,
            length: 0
          }
          this.fileName = ''
          this.$emit('change', '')
        }
      },
      setFileName (files) {
        const sliceFileName = (str) => {
          if (str.length <= 25) {
            return str
          }
          return `${str.substr(0, 6)}...${str.substr(str.length - 10)}`
        }
        if (files.length > 1) {
          this.fileName = `${files.length} files`
        } else {
          this.fileName = sliceFileName(files[0].name)
        }
      },
      clearInput () {
        this.$refs.fileInput.value = ''
        this.onFileChange(null)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .upload-file-btn {
    display: flex;
    align-items: center;
    &__main-btn {
      border: 1px solid lighten(#6C9D39, 20%);
      color: lighten(#6C9D39, 20%);
    }
    &__info {
      margin-left: 8px;
    }
  }
</style>
